import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: 'AIzaSyD5owNekhcRY2KCiHGem9GZWR5dak8QMEo',
  authDomain: 'homigo-21c78.firebaseapp.com',
  projectId: 'homigo-21c78',
  storageBucket: 'homigo-21c78.firebasestorage.app',
  messagingSenderId: '984706838227',
  appId: '1:984706838227:web:cd15f221a21b8341ff2e26',
  measurementId: 'G-MP2YF6T4ES',
};

// 🔥 init
const app = initializeApp(firebaseConfig);

// 🔥 remote config
export const remoteConfig = getRemoteConfig(app);

// ⚙️ settings
remoteConfig.settings = {
  minimumFetchIntervalMillis: 10000,
  fetchTimeoutMillis: 60000,
};

// 🧠 default values
remoteConfig.defaultConfig = {
  maintenance_mode: false,
};
